import { Ability } from '@casl/ability';

export const ability = new Ability([]);

export default function (app) {
    const permissions = localStorage.getItem('Permissions');
    if (permissions) {
        ability.update(JSON.parse(permissions));
    }
    app.config.globalProperties.$ability = ability;
}
